import { Body, Box, Bullets } from '../widgets'
import { subscriptionTypes } from '../../lookups'

export const SubscriptionFeatures = ({ subscriptionType, dark }) => (
  <Box className="text-list" fullWidth>
    <Body color={dark ? "black" : "white"} bold alt>{subscriptionTypes[subscriptionType].benefitTitle}</Body>
    <Bullets items={subscriptionTypes[subscriptionType].benefits} dark={dark}/>
  </Box>
)